import { Action, createReducer, on } from '@ngrx/store';
import { IMarketingResponse } from '../models/marketing-options.model';
import * as actions from '../actions';

export const getMarketingFeatureKey = 'getMarketing';

export interface MarketingState {
  loadMarketingResponse: IMarketingResponse;
  loaded: boolean;
}

export const initialState: MarketingState = {
  loadMarketingResponse: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.loadGetMarketingOptionsSuccess, (state, action) => ({
    ...state,
    loadMarketingResponse: action.response,
    loaded: true
  }))
);

export const getMarketingResponse = (state: MarketingState) => state.loadMarketingResponse;

export const getMarketingLoaded = (state: MarketingState) => state.loaded;
